/*
 * Public API Surface of material-dayjs-adapter
 */

export * from './lib/adapter/index';
export { MAT_DAYJS_DATE_ADAPTER_OPTIONS } from './lib/adapter/dayjs-date-adapter';
export { MAT_DAYJS_DATE_FORMATS } from './lib/adapter/dayjs-date-formats';
